const notificationApi = {
  notification: {
    settings: '/api/notices/settings',
    list: '/api/notices/list',
    telegram: {
      link: '/api/users/generate_tg_link',
      unlink: '/api/users/unlink_tg_account',
      status: '/api/notices/telegram/status',
    },
  },
};

export default notificationApi;

export const notificationApiConfig = notificationApi.notification;
